import {compose, pick} from 'ramda'
import {
  FIELD_NAME_TO_PROPERTY_NAME_MAPPING,
  LEGAL_REPRESENTATIVES_DOCUMENT_INPUT_FIELD_NAMES,
  LEGAL_REPRESENTATIVES_PERSON_INPUT_FIELD_NAMES,
  LEGAL_REPRESENTATIVES_ROLE_INPUT_FIELD_NAMES,
} from './constants'

export const pickLegalRepresentativePersonProperties = pick(
  LEGAL_REPRESENTATIVES_PERSON_INPUT_FIELD_NAMES
)
export const pickLegalRepresentativeRoleProperties = pick(
  LEGAL_REPRESENTATIVES_ROLE_INPUT_FIELD_NAMES
)
export const pickLegalRepresentativeDocumentProperties = pick(
  LEGAL_REPRESENTATIVES_DOCUMENT_INPUT_FIELD_NAMES
)
const pickAllLegalRepresentativeProperties = pick([
  ...LEGAL_REPRESENTATIVES_PERSON_INPUT_FIELD_NAMES,
  ...LEGAL_REPRESENTATIVES_ROLE_INPUT_FIELD_NAMES,
])

const fieldNameToProperty = (fieldName: string): string => {
  if (FIELD_NAME_TO_PROPERTY_NAME_MAPPING[fieldName]) {
    return FIELD_NAME_TO_PROPERTY_NAME_MAPPING[fieldName]
  }
  return fieldName.replace('legalRepresentative.', '')
}

export const mapLegalRepresentativeToRequest = (
  formData: Record<string, any>
): Record<string, any> =>
  Object.fromEntries(
    Object.entries(formData).map(([fieldName, value]) => [fieldNameToProperty(fieldName), value])
  )

const propertyToFieldName = (propertyName: string): string => {
  if (Object.values(FIELD_NAME_TO_PROPERTY_NAME_MAPPING).includes(propertyName)) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return Object.entries(FIELD_NAME_TO_PROPERTY_NAME_MAPPING).find(
      ([, value]) => value === propertyName
    )![0]
  }
  return `legalRepresentative.${propertyName}`
}

const mapLegalRepresentativePropertiesToInputFieldNames = (
  legalRepresentative: Record<string, any>
): Record<string, any> =>
  Object.fromEntries(
    Object.entries(legalRepresentative).map(([propertyName, value]) => [
      propertyToFieldName(propertyName),
      value,
    ])
  )

export const mapLegalRepresentativeToFormData = compose(
  pickAllLegalRepresentativeProperties,
  mapLegalRepresentativePropertiesToInputFieldNames
)
